<template>
    <div class="unity-values">
        <div class="unity-values-price">
            <div class="title">Valor do m²</div>
            <div class="subtitle">Defina o valor base das unidades.</div>
            <form class="unity-values-price-form">
                <div class="col input-group">
                    <ui-input v-model="baseCost" group="R$" invertgroup />
                    <ui-button design="primary md" @click="saveBaseCost">Salvar</ui-button>
                </div>
            </form>
        </div>

        <div class="unity-values-categories">
            <div class="title">Categorias de Unidades</div>
            <div class="subtitle">
                As categorias proporcionam facilidade na gestão de preços através do peso. Uma unidade poderá ser ou não
                vinculada a uma categoria, o valor da unidade será baseado no peso da categoria vinculada e ao m².
            </div>

            <div class="register-categories">
                <!-- @start .register-categories-table -->
                <div v-if="categories.length > 0" class="register-categories-table ui-table">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>&nbsp;</th>
                                <th>Nome</th>
                                <th>Peso em %</th>
                                <th>Cor</th>
                                <th>Legenda</th>
                                <th width="40">&nbsp;</th>
                            </tr>
                        </thead>

                        <tbody>
                            <ui-table-line v-for="(item, i) in categories" :key="item.id" :data="item" :index="i" />
                        </tbody>
                    </table>
                </div>
                <!-- @end .register-categories-table -->

                <div v-else class="no-data">
                    <span>Nenhuma categoria cadastrada.</span>
                </div>

                <div class="buttons">
                    <ui-button design="primary md" @click="openModal('modal-unity-values-add-category')">
                        Adicionar categoria
                    </ui-button>
                </div>
            </div>
        </div>
        <!-- Modal de confirmação ao criar nova tabela -->
        <modal-unity-values-add-category />
    </div>
</template>

<script>
	import { uiInput } from '@/components/ui/form'
	import { uiButton } from '@/components/ui/buttons'
	import uiTableLine from '@/components/ui-facilita/products/step-four/unity-values-categories/table-line'
	import modalUnityValuesAddCategory from './components/modal-unity-values-add-category'

	import { availability } from '@/services/axios'

	import { format, unformat } from '@/directives/money/utils'

	const defaultFormData = (data) => {
		return {
			id: data.id,
			base_cost: data.base_cost
				? parseFloat(data.base_cost).toFixed(2)
				: null
		}
	}

	export default {
		name: 'step-four-prices',

		components: {
			uiInput,
			uiButton,
			uiTableLine,
			modalUnityValuesAddCategory,
		},

		props: {
			data: {
				type: [Array, Object],
				required: true,
				default() {
					return {
						id: null,
						base_cost: 0
					}
				},
			},
		},

		data() {
			return {
				editingColor: '#3B4350',
				isEditingColor: false,
				name: null,
				percent: null,
				categories: [],
				obj: {},
				form: {
					data: {},
				},
				unsubscribe: null
			}
		},

		computed: {
			/**
			 * Computed property que controla o valor da metragem, formatando ou limpando
			 */
			baseCost: {
				get() {
					return parseFloat(this.form.data.base_cost) >= 0
						? format(this.form.data.base_cost)
						: ''
				},
				set(value) {
					this.form.data.base_cost = value ? unformat(format(value), 2) : null
				}
			}
		},

		mounted() {
			if (this.data.id) {
				this.form.data = { ...defaultFormData(this.data) }
			}
			if (this.data.groups) {
				this.categories = [...this.data.groups]
			}
		},

		created() {
			this.unsubscribe = this.$store.subscribe((mutation) => {
				if (mutation.type === 'productCategory/SAVED_PRODUCT_CATEGORY') {
					this.categories.push(mutation.payload)
				}
				if (mutation.type === 'productCategory/UPDATE_PRODUCT_CATEGORY') {
					this.categories = this.categories.map(function (value) {
						if (value.id == mutation.payload.id) {
							value = mutation.payload
						}
						return value
					})
				}
				if (mutation.type === 'productCategory/DELETE_PRODUCT_CATEGORY') {
					this.categories = this.categories.filter(function (value) {
						if (value.id != mutation.payload.data.id) {
							return value
						}
					})
				}
			})
		},

		methods: {
			/**
			 * Atualiza o valor base das unidades de uma disponibilidade
			 */
			saveBaseCost() {
				if (!this.form.data.id) return

				const data = {
					base_cost: this.form.data.base_cost,
				}

				availability
					.update('', this.form.data.id, data)
					.then((response) => {
						this.$toastr.s(response.data.msg)
					})
					.catch((error) => {
						if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
						console.log(error)
					})
			},
			/**
			 * Abrir o Modal
			 */
			openModal(name) {
				this.$store.dispatch('productCategory/setProductAvailability', this.data)
				this.$root.$emit('modal-open-' + name, true)
			},
			/**
			 * Fechar o modal
			 */
			closeModal() {
				this.$root.$emit('modal-close-' + name)
			}
		}
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl';
</style>
